export default {
  data() {
    return {
      phoneTypes: [
        'Celular',
        'Local',
      ],
      emailTypes: [
        'Principal',
      ],
      contactDtlstatus: [
        {
          name: 'Invalido',
          icon: 'fas fa-times-circle',
          color: 'red ligthen-1',
        },
        {
          name: 'Valido',
          icon: 'fas fa-check-circle',
          color: 'green',
        },
        {
          name: 'Equivocado',
          icon: 'fas fa-times-circle',
          color: 'red ligthen-1',
        },
        {
          name: 'Por validar',
          icon: 'fas fa-exclamation-circle',
          color: 'yellow darken-3',
        },
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./src/mixins/contactDtl.js